import {
  ShipmentDispatchBriefDispatchType,
  ShipmentStatus,
} from '#/shared/api/generated/shipment/models'
import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'

import { isDispatchedStatus } from './order-statuses'

function hasSuperDispatch(shipment: ShipmentDetail): boolean {
  return (
    shipment.dispatches?.some(
      (d) => d.dispatch_type === ShipmentDispatchBriefDispatchType.super,
    ) ?? false
  )
}

/** Header (toolbar) Requests button: posted stage only — once the shipment
 * reaches a dispatched status (not_signed onward) the Super Dispatch loadboard
 * row owns the Requests entry point instead. */
export function shouldShowCarrierRequests(
  shipment: ShipmentDetail | undefined,
): boolean {
  if (!shipment) return false
  if (isDispatchedStatus(shipment.status)) return false
  const count = shipment.carrier_requests_count ?? 0
  if (count > 0) return true
  return shipment.status === ShipmentStatus.posted && hasSuperDispatch(shipment)
}
